var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit-square") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/edit-square",
    transform: "translate(-2.000000, -2.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-square",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1875,12 L19.875,12 C19.771875,12 19.6875,12.084375 19.6875,12.1875 L19.6875,19.6875 L4.3125,19.6875 L4.3125,4.3125 L11.8125,4.3125 C11.915625,4.3125 12,4.228125 12,4.125 L12,2.8125 C12,2.709375 11.915625,2.625 11.8125,2.625 L3.375,2.625 C2.96015625,2.625 2.625,2.96015625 2.625,3.375 L2.625,20.625 C2.625,21.0398438 2.96015625,21.375 3.375,21.375 L20.625,21.375 C21.0398437,21.375 21.375,21.0398438 21.375,20.625 L21.375,12.1875 C21.375,12.084375 21.290625,12 21.1875,12 Z",
    id: "Path",
    fill: "#205527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34140625,12.5367187 L8.29685088,15.3234375 C8.29453125,15.5320312 8.46328125,15.703125 8.671875,15.703125 L8.68125,15.703125 L11.446875,15.6351562 C11.49375,15.6328125 11.540625,15.6140625 11.5734375,15.58125 L21.3210937,5.8546875 C21.39375,5.78203125 21.39375,5.6625 21.3210937,5.58984375 L18.4078125,2.67890625 C18.3703125,2.64140625 18.3234375,2.625 18.2742187,2.625 C18.225,2.625 18.178125,2.64375 18.140625,2.67890625 L8.3953125,12.4054687 C8.3625,12.440625 8.34140625,12.4875 8.34140625,12.5367187 Z M9.8296875,13.0898437 L18.2742187,4.6640625 L19.3335937,5.72109375 L10.884375,14.1515625 L9.81328125,14.1773437 L9.8296875,13.0898437 L9.8296875,13.0898437 Z",
    id: "Shape",
    fill: "#205527"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit-square.2a8feede65b5bc8eeff70cb9a61d347a.svg";
export { ForwardRef as ReactComponent };